import cx from "classnames";
import { ArrowDropUp } from "@bloomberg/media-ui-iconography";

import { BigPillProps } from "./types";

import styles from "./styles.module.css";

const getClassNameBasedOnChangeDirection = (percentChange) =>
  percentChange > 0
    ? styles.up
    : percentChange < 0
      ? styles.down
      : styles.neutral;

export const PercentChange = ({ percentChange }) => {
  const prefix = percentChange > 0 ? "+" : "";

  return (
    <div className={styles.percentChangeContainer}>
      <div className={styles.triangle}>
        <ArrowDropUp aria-label="Arrow" width={12} height={12} />{" "}
      </div>
      <div className={styles.percentChange}>
        {prefix}
        {Number(percentChange)?.toFixed(2)}%
      </div>
    </div>
  );
};

PercentChange.displayName = "BigPill.PercentChange";

export function Component(props: BigPillProps) {
  const { label, value, percentChange } = props;

  return (
    <div
      className={cx(
        styles.bigPillContainer,
        getClassNameBasedOnChangeDirection(percentChange)
      )}
    >
      <label className={styles.label}>{label}</label>
      <div className={styles.bottomRow}>
        <div className={styles.value}>{value?.toFixed(2)}</div>
        <PercentChange percentChange={percentChange} />
      </div>
    </div>
  );
}
Component.displayName = "BigPill.Component";
